var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChesscomLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 280 400",
    style: {
      enableBackground: "new 0 0 290 400"
    },
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{clip-path:url(#SVGID_2_);fill:#81b64c}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M0 0h290v400H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145 400c151.9 0 145-46.5 145-55.9 0-35.8-13.4-74.5-44.4-98.1-16.1-12.3-25.1-23-30.2-32.6 10.6 0 12.9-1.8 16.8-7.3 13.1-18.8 18.9-38.2 16-61.2-.8-6.2-3.6-10.1-8.7-13.4l-13.9-9.1c4.6-10.7 7.1-22.3 7.1-34.5C232.6 39.2 193.3 0 145 0S57.4 39.2 57.4 87.8c0 12.1 2.5 23.8 7.1 34.5l-13.9 9.1c-5.1 3.4-8 7.3-8.7 13.4-3 23 2.9 42.4 16 61.2 3.8 5.5 6.1 7.3 16.8 7.3-5.1 9.5-14 20.2-30.2 32.6C13.5 269.5 0 308.1 0 344c0 9.5-6.9 56 145 56z",
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#2e2c29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 273.7c-55.7-42.6-49.5-79.5-50.2-94.7h34c4-7.4 6-14.2 6-22.8l-38.5-25.4c13.4-9.7 22.1-25.5 22.1-43.3 0-22.4-13.8-41.7-33.4-49.6-6.2-2.5-49.8 141.1-49.8 141.1-.2 3.3-.2 7.6-.2 12.8 0 14.3 35 12.1 33.1 24.7-2.8 18.8-3.4 33.2-19.6 78.4-10.9 30.6-83.8 0-89 15-3.6 10.4-5.5 22.1-5.5 34.7 0 1.3 2.9 21.5 111 21.5s111-20.2 111-21.5c0-30.7-11.4-56-31-70.9z",
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#5d9948"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M143 292.8c6-27.4 11.3-56.6 14.6-74.1 4-21.8-29-25.7-42.6-27.7-.6 18.6-5.8 48.9-50.1 82.7-11.9 9.1-20.8 22.1-26 37.9 12 5.8 27.9 9.3 52.5 9.3 15.8 0 45 1.9 51.6-28.1zM166.2 178.9c5.2-13.6 4.6-22.8 4.6-22.8L149 130.7c23.2-9.9 37.2-28.6 37.2-50.3 0-17.3-8.3-32.8-21-42.5-6.2-2.5-13-4-20.1-4-29.5 0-53.4 23.9-53.4 53.5 0 17.8 8.7 33.6 22.1 43.3l-38.5 25.4c0 8.5 2 15.4 6 22.8h84.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142 44.9c30.8 4.8-14.2 40.6-28.4 38.9-13.5-1.7-.5-43.4 28.4-38.9z",
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#b2e068"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChesscomLogo);
export default __webpack_public_path__ + "static/media/chesscom_logo.f1039dfea189196428d73beff292e172.svg";
export { ForwardRef as ReactComponent };